import { createFileRoute } from '@tanstack/react-router';
import Builder from 'src/pages/Organization/Players/Characters/Builder';

export const Route = createFileRoute(
  '/$organizationSlug/players/$playerId/characters/$characterId/',
)({
  component: Builder,
});
